import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import CaseComponent from "../common/CaseComponent";
import RunNewSearch from "./RunNewSearch";
import { getErrorComponent } from "../messages/ErrorComponent";
import { hideCaseManagement } from "../../utils/PageHelper";
import settings from "../../settings";

class ResultHeader extends Component {
  componentDidMount() {}

  render() {
    const { searchResultData, leftMenuReportId, formData } = this.props;
    const log = _.get(
      this.props.searchResultData,
      `${Object.keys(this.props.searchResultData)[0]}.log[0]`,
      ""
    );
    const searchCriteria = _.get(
      this.props.searchResultData,
      `${Object.keys(this.props.searchResultData)[0]}.log[0].actDesc[0]`
    );
    const printContent = this.props.printContent;
    let criteria = "";
    if (searchCriteria !== undefined)
      if (searchCriteria.indexOf("with") !== -1)
        criteria = searchCriteria.substring(0, searchCriteria.indexOf("with"));
      else criteria = searchCriteria;
    const { additionalData } = this.props;
    const actCharge = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actCharge[0]`
    );
    const actType = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actType[0]`
    );
    const actPrice = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actPrice[0]`
    );
    return (
      <Table key={"table_info"}>
        <Table.Body>
          <Table.Row className="result-criteria-header">
                    <Table.Cell width={10} className={"icon-align-middle extra-large-font"}>
              {criteria}
            </Table.Cell>
            <Table.Cell width={4}>
              {!hideCaseManagement(settings.hideCaseManagementAtFormsForReports
                , leftMenuReportId || (formData && formData.reportID)
                || (additionalData && additionalData.reportIds && additionalData.reportIds[0])) 
                && <div className={`no-print float-right`}>
                <CaseComponent
                  {...this.props}
                  actId={_.get(
                    this.props.searchResultData,
                    `${
                      Object.keys(this.props.searchResultData)[0]
                    }.log[0].actID[0]`
                  )}
                  comptType={"result"}
                />
              </div>}
            </Table.Cell>
            <Table.Cell width={2}>
              <div className={`no-print float-right margin-top-3`}>
                <Button
                  className={"margin-left-10"}
                  onClick={() =>
                    printContent("result", `Results - ${criteria}`)
                  }
                >
                  Print
                </Button>
              </div>
            </Table.Cell>
          </Table.Row>
          {log && (
            <RunNewSearch
              actID={_.get(log, "xmlID[0]")}
              actDate={_.get(log, "actDate[0]")}
              actType={_.get(log, "actType[0]")}
              reportID={_.get(log, "reportID[0]")}
              showResults={this.props.showResults}
              data={this.props.formData}
            />
          )}
          {this.props.showNarrowSearchMessage && (
            <Table.Row>
              <Table.Cell colSpan={2}>
                <center>
                  Please narrow your search: you only get upto 3 addresses and
                  no phone numbers when over 25 matches were found.
                </center>
              </Table.Cell>
            </Table.Row>
          )}
          {additionalData &&
            additionalData.errorMessage &&
            additionalData.errorMessage !== "" && (
              <Table.Row>
                <Table.Cell colSpan={3}>
                  {getErrorComponent(
                    additionalData.errorMessage,
                    actCharge,
                    actType,
                    actPrice
                  )}
                </Table.Cell>
              </Table.Row>
            )}
        </Table.Body>
      </Table>
    );
  }
}

export default ResultHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/ResultHeader.js